<template>
    <div>
        <br>
        <h3 class="text-center">นำเข้าเวลาพนักงาน</h3>
        <div class="row form-group text-right">
            <div class="col-4">
                พนักงาน
            </div>
            <div class="col-6">
                <multiselect
                    v-model="form.employee"
                    :options="optionEmployee"
                    select-label=""
                    deselectLabel=""
                    placeholder="เลือกพนักงาน"
                    :customLabel="employeeLabel"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">
                แผนก
            </div>
            <div class="col-6">
                <multiselect
                    v-model="form.department"
                    :options="optionDepartment"
                    placeholder="เลือกแผนก"
                    select-label=""
                    deselectLabel=""
                    label="department_name"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">
                วันที่
            </div>
            <div class="col-6">
                <date-picker
                    v-model="form.date"
                    type="date"
                    :lang="lang"
                    :format="changeFormat"
                    placeholder="วันที่"
                    confirm>
                </date-picker>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">
                เวลานำเข้า
            </div>
            <div class="col-6">
                <date-picker
                    v-model="form.scan_in"
                    type="time"
                    :lang="lang"
                    format="HH:mm"
                    placeholder="เวลานำเข้า"
                    confirm>
                </date-picker>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">
                เวลาพัก
            </div>
            <div class="col-6">
                <date-picker
                    v-model="form.scan_break_out"
                    type="time"
                    :lang="lang"
                    format="HH:mm"
                    placeholder="เวลาพัก"
                    confirm>
                </date-picker>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">
                เวลาเลิกพัก
            </div>
            <div class="col-6">
                <date-picker
                    v-model="form.scan_break_in"
                    type="time"
                    :lang="lang"
                    format="HH:mm"
                    placeholder="เวลาเลิกพัก"
                    confirm>
                </date-picker>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">
                เวลาออกจากงาน
            </div>
            <div class="col-6">
                <date-picker
                    v-model="form.scan_out"
                    type="time"
                    :lang="lang"
                    format="HH:mm"
                    placeholder="เวลาออกจากงาน"
                    confirm>
                </date-picker>
            </div>
        </div>
        <div class="col text-center">
            <button v-if="canViewHR != form.employee.is_hr || canViewSuperAdmin"
                    type="button"
                    @click="submitData"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก
            </button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
        <!--        <pre>{{test_data}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker';
import moment from "moment";
import {canViewHR, canViewSuperAdmin} from "../../../util/Permissions";

export default {
    name: "AddTimeScanModal",
    components: {
        Multiselect, DatePicker
    },
    created() {
        this.getEmployeeAll();
        this.getDepartmentAll();
    },
    data() {
        return {
            test_data: [],
            form: {
                employee: '',
                department: '',
                date: '',
                scan_in: '',
                scan_out: '',
                scan_break_out: '',
                scan_break_in: '',
            },
            optionEmployee: [],
            optionDepartment: [],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            canViewHR,
            canViewSuperAdmin,
            optionPosition: state => {
                return state.Common.position
            },
            user: state => {
                return state.Auth.user;
            },
        })
    },
    methods: {
        getDepartmentAll() {
            this.$store.dispatch("Department/getAllDepartment").then(res => {
                this.optionDepartment = res;
            })
        },
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        getEmployeeAll() {
            this.$store.dispatch("Employee/getEmployeeAll").then(res => {
                this.optionEmployee = res.filter(c => (c.work_status && c.work_status.active_status_id != 2) || !c.work_status);
                // this.optionEmployee = res;
            });
        },
        submitData() {
            if (!this.form.date) {
                alert('กรุณาเลือกวันที่');
            } else if (!this.form.employee && !this.form.department) {
                alert('กรุณาพนักงาน หรือ แผนก')
            } else {
                let scan_in = this.form.scan_in ? moment(this.form.scan_in).format("HH:mm:ss") : '';
                let scan_break_in = this.form.scan_break_in ? moment(this.form.scan_break_in).format("HH:mm:ss") : '';
                let scan_break_out = this.form.scan_break_out ? moment(this.form.scan_break_out).format("HH:mm:ss") : '';
                let scan_out = this.form.scan_out ? moment(this.form.scan_out).format("HH:mm:ss") : '';
                let time_array = [scan_in, scan_break_in, scan_break_out, scan_out];
                let data = {
                    employee_id: this.form.employee ? this.form.employee.id : '',
                    position_id: this.form.position ? this.form.position.id : '',
                    date: this.form.date ? moment(this.form.date).format("YYYY-MM-DD") : '',
                    time_scan: time_array,
                }
                this.test_data = data;
                this.$emit('submit', data);
            }
        },
        cancelData() {
            this.$emit('submit', false);
        }
    }
}
</script>

<style scoped>

</style>
